// GENERATED by scripts/gen-wire-types.mjs from core/src/wire.rs.
// Do not edit by hand. Run `npm run wasm:node` (or `npm run wire-types`).

export const GENERATED_WEAPON_NAMES = [
  "None",
  "Melee",
  "Machinegun",
  "Shotgun",
  "Grenade Launcher",
  "Rocket Launcher",
  "Plasma Gun",
  "Lightning Gun",
  "Railgun",
  "Experimental",
  "Ball Launcher",
] as const;

export const GENERATED_WEAPON_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const;
